"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateWithResetter = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var tuple_1 = require("../functions/tuple");
var useStateWithResetter = function (initialState) {
    var _a = tslib_1.__read((0, react_1.useState)(initialState), 2), state = _a[0], setState = _a[1];
    var resetState = (0, react_1.useCallback)(function () {
        setState(initialState);
    }, [setState, initialState]);
    return (0, tuple_1.t)(state, setState, resetState);
};
exports.useStateWithResetter = useStateWithResetter;
